export default __webpack_public_path__ + "static/media/logoTypeWOslogan-blue.40683753.png";